import React from "react";
import { Image } from "react-bootstrap";

export default function Avatar({ user, size = 38 }) {
  const initials = (() => {
    const name = `${user?.first_name || ""} ${user?.last_name || ""}`.trim();
    if (!name) return "U";
    const parts = name.split(" ");
    return parts.length === 1
      ? parts[0][0].toUpperCase()
      : (parts[0][0] + parts[1][0]).toUpperCase();
  })();

  // Determine image source
  const IMAGE_BASEURL = process.env.REACT_APP_IMAGE_BASEURL || "";
  const rawImage = user?.profile_picture || user?.profile_picture_path || user?.image || user?.photo || "";
  
  let imageSrc = null;
  if (rawImage) {
    if (rawImage.startsWith("http") || rawImage.startsWith("blob")) {
        imageSrc = rawImage;
    } else {
        imageSrc = `${IMAGE_BASEURL}${rawImage}`;
    }
  }

  if (imageSrc) {
    return (
      <Image
        src={imageSrc}

        roundedCircle
        width={size}
        height={size}
        style={{ objectFit: "cover", border: "1px solid #dee2e6" }}
        onError={(e) => (e.target.src = `https://ui-avatars.com/api/?name=${initials}`)}
      />
    );
  }

  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: "50%",
        backgroundColor: "#6c757d",
        color: "#fff",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontWeight: "bold",
      }}
    >
      {initials}
    </div>
  );
}
